import { TextFieldInput } from "@smart/itops-sb-design-system-dom";

import { FieldGroup } from "./field-group";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";

export const EmailField = ({
  field,
  index,
  innerRef,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
}: FieldProps<HTMLInputElement>) => {
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
      >
        <TextFieldInput
          ref={innerRef}
          id={id}
          name={id}
          error={!!error}
          message={error ?? undefined}
          value={value ?? ""}
          aria-invalid={!!error}
          aria-errormessage={errorId ?? undefined}
          type="text"
          inputMode="email"
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          formNoValidate
        />
      </FieldGroup>
    </FieldWrapper>
  );
};
